import React, { useEffect, useState } from "react";
import { getSliders } from "../axios";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import img1 from "../assets/img/slider/new-slide1.jpg";
import img2 from "../assets/img/slider/new-slide2.jpg";
import img3 from "../assets/img/slider/new-slide3.jpg";
import img4 from "../assets/img/slider/new-slide4.jpg";
import { Swiper } from "swiper/react";
import { HashNavigation, Navigation, Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";

const Slider = () => {
  const [slideImages, setslideImages] = useState([]);

  useEffect(() => {
    getSliders().then(({ data }) => {
      setslideImages(data);
    });
  }, []);

  const imgList = [
    {
      id: 1,
      img: img1,
    },
    {
      id: 2,
      img: img2,
    },
    {
      id: 3,
      img: img3,
    },
    {
      id: 4,
      img: img4,
    },
  ];

  return (
    <section style={{ direction: "ltr" }} className="slider_section mb-70">
      <div className="slide-container">
        {slideImages.length > 0 && (
          <Carousel showThumbs={false} autoPlay={true} infiniteLoop={true}>
            {slideImages.map((slideImage, index) => (
              <a
                key={index}
                href={slideImage.link !== "" ? `${slideImage.link}` : ""}
                target="_blank"
                without
                rel="noreferrer"
              >
                <div className="container-lg mainSlider-banner" style={{ cursor: "pointer" }}>
                  <img
                    src={slideImage.sliderurl}
                    alt="Carousel_Image"
                    className="my-4 mx-auto shadow-sm"
                  />
                </div>
              </a>
            ))}
          </Carousel>
        )}

        <br />
        
        <p className="underSlider-title text-center">با کلیک بروی تصویر مدنظر از صفحه مرتبط با آن بازدید نمایید</p>

      <div className="exam-header-title d-flex align-items-center justify-content-center">
        <h2 className="fw-bold">
          <Link target="_blank" to={"https://azmoon.atropine.ir/"}>          سامانه آزمون های آنلاین <span>آتروپین</span> 
          </Link>
        </h2>
      </div>

        {/* ---------------------------------------------- slider under image --------------------------------------- */}

        <div className="container-lg">
          
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            hashNavigation={{
              watchState: true,
            }}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              400: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 40,
              },
            }}
            navigation={true}
            modules={[Pagination, Navigation, HashNavigation]}
            className="mySwiper"
          >
            <div className="img-under-slider">
              {imgList?.map((item) => (
                <div key={item.id} className="col-lg-3">
                  <SwiperSlide className="d-flex align-items-center justify-content-center">
                    <Link className="d-flex align-items-center justify-content-center" to={`shop?catId=${item.id}`}>
                      <img
                        className="each-img"
                        src={item.img}
                        alt="under_Slider1"
                        style={{
                          width: "100%",
                          maxHeight: "320px",
                          objectFit: "contain",
                          cursor: "pointer",
                        }}
                      />
                    </Link>
                  </SwiperSlide>
                </div>
              ))}
            </div>
          </Swiper>
        </div>

        {/* ---------------------------------------------------------------------------------------------------------- */}

        {/* <div className="container-lg">
          <div className="row">
            <div className="col-lg-4 col-sm-6">
              <div className="single-product">
                <div className="product-img ">
                  <img
                    src={img1}
                    className="border shadow-sm rounded-2"
                    alt="under_Slider1"
                    style={{ width: "100%", height: "400px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="single-product">
                <div className="product-img">
                  <img
                    src={img2}
                    className="border shadow-sm rounded-2"
                    alt="under_Slider2"
                    style={{ width: "100%", height: "400px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="single-product">
                <div className="product-img">
                  <img
                    src={img3}
                    className="border shadow-sm rounded-2"
                    alt="under_Slider3"
                    style={{ width: "100%", height: "400px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Slider;
